import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Button,
  DialogActions,
} from "@material-ui/core";
import * as React from "react";
import { colors } from "../constants/constants";
const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    margin: {
      margin: theme.spacing(1),
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  dialogTitle: any;
  signature: any;
  onClose: any;
}
class ViewSignatureDialog extends React.Component<Props> {
  state = {};
  handleClose = () => {
    this.props.onClose();
  };
  componentDidMount = () => {};

  componentDidUpdate = () => {};

  render() {
    const { open, signature, onClose } = this.props;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Viewing Signature for: ${
            signature &&
            signature.signatureItem &&
            signature.signatureItem.fullName
              ? signature.signatureItem.fullName
              : ""
          }`}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div>
            <img
              alt={"Signature view"}
              style={{ width: "100%", height: 80 }}
              src={`data:image/png;base64,${signature.base64}`}
            />
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={onClose} autoFocus>
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(ViewSignatureDialog);
